import { Card, CardContent } from '@mui/material';

const dataTestId = {
  wrapper: 'widget-card.wrapper',
};

const EligibilityWidgetCard: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Card data-testid={dataTestId.wrapper}>
    <CardContent>{children}</CardContent>
  </Card>
);

export default EligibilityWidgetCard;
